import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import { formatDateTime } from "./utility";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const qrCodePdfDownloadAPI = createApi({
  reducerPath: "qrCodePdfDownloadAPI",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["qrCodePdfDownload"],
  endpoints: (builder) => ({
    exportToPDF: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.pdfExportController.exportToPDF}${body.bookingCode}/${body.bookingId}/${body.subBookingId}/${body.flag}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
          responseType: 'blob'
        };
      },
    }),
  }),
});

export const { useExportToPDFMutation } = qrCodePdfDownloadAPI;
